import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './zh-CN'
import enUS from './en-US'
import ElementUiEn from "element-ui/lib/locale/lang/en"
import ElementUiZh from "element-ui/lib/locale/lang/zh-CN"

Vue.use(VueI18n)

export const messages = {
  'zh-CN': {
    '_lang': '简体中文',
    ...zhCN,
    ...ElementUiZh,

  },
  'en-US': {
    '_lang': 'English',
    ...enUS,
    ...ElementUiEn,

  }
}
// let lan = navigator.systemLanguage || navigator.language;
// console.log("lanlan", lan);
// localStorage.setItem('language', lan)
localStorage.setItem('language', 'en-US')

export default new VueI18n({
  locale: localStorage.getItem('language') || 'en-US',
  messages
})
